module.exports = __webpack_public_path__ + "static/media/PR_01_C.ec55b7f8.png";